import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Toast } from "ngx-toastr";

@Component({
    selector: "dtm-ui-custom-close-button-toast",
    templateUrl: "./custom-close-button-toast.component.html",
    styleUrls: ["./custom-close-button-toast.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomCloseButtonToastComponent extends Toast {}
